(function () {
    var API_URL = "https://service.tangent.ai/shopify/get-checkout-products";
    var CART_ADD_URL = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + "cart/add.js"
        : "/cart/add.js";
    var TABS = [
        { key: "full", label: "Full Routine", match: /full/i },
        { key: "byob", label: "Build your own", match: /byob/i },
        { key: "starter", label: "Starter SET", match: /starter/i },
    ];
    var ADD_ON_SECTION_KEY = "section_add_on_for_pregnant_users";

    var root = document.getElementById("sc-reco");
    if (!root) return;

    var loader = document.getElementById("sc-reco-loader");
    var errorBlock = document.getElementById("sc-reco-error");
    var content = document.getElementById("sc-reco-content");
    var tabsEl = document.getElementById("sc-reco-tabs");
    var panelsEl = document.getElementById("sc-reco-panels");

    function init() {
        var respId = new URLSearchParams(window.location.search).get("resp_id");
        if (!respId) {
            showError();
            return;
        }

        fetch(API_URL + "?resp_id=" + encodeURIComponent(respId) + "&self_serve=true&multiple_recommendation_sections=true")
            .then(function (response) {
                if (!response.ok) throw new Error("Recommendation API error " + response.status);
                return response.json();
            })
            .then(function (data) {
                var tabs = buildTabs(data);
                if (!tabs.length) throw new Error("No recommended products");

                renderTop(data);
                setPersonaFromTags(data);
                renderTabs(tabs);
                loader.hidden = true;
                content.hidden = false;
            })
            .catch(function (err) {
                console.error("[Skin Clique reco]", err);
                showError();
            });
    }

    function showError() {
        loader.hidden = true;
        content.hidden = true;
        errorBlock.hidden = false;
    }

    // --- Helpers ---

    function escapeHtml(value) {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    function normalizeId(id) {
        return String(id || "").split("/").pop();
    }

    function textSectionHtml(data, key) {
        var value = data && data.text_sections && data.text_sections[key];
        if (!value) return "";
        return Array.isArray(value) ? value.join("") : String(value);
    }

    function getVariants(product) {
        var edges = product && product.variants && product.variants.edges;
        if (Array.isArray(edges)) {
            return edges.map(function (edge) { return edge && edge.node; }).filter(Boolean);
        }
        if (product && Array.isArray(product.variants)) return product.variants;
        return [];
    }

    function isVariantAvailable(variant) {
        return !!variant &&
            variant.availableForSale !== false &&
            variant.available_for_sale !== false &&
            variant.available !== false;
    }

    function getVariantAmount(variant) {
        if (!variant) return 0;
        var raw = variant.price && typeof variant.price === "object" ? variant.price.amount : variant.price;
        var amount = Number(raw);
        if (Number.isNaN(amount)) return 0;
        if (amount >= 100 && String(raw).indexOf(".") === -1) amount = amount / 100;
        return amount;
    }

    function formatMoney(amount) {
        try {
            return new Intl.NumberFormat(root.dataset.locale || undefined, {
                style: "currency",
                currency: root.dataset.currency || "USD",
            }).format(amount);
        } catch (err) {
            return "$" + amount.toFixed(2);
        }
    }

    function getProductImage(product, variant) {
        if (variant && variant.image) return variant.image.url || variant.image.src || "";
        var edges = product && product.images && product.images.edges;
        var node = Array.isArray(edges) && edges[0] && edges[0].node;
        if (node && (node.url || node.src)) return node.url || node.src;
        if (product && Array.isArray(product.images) && product.images[0]) {
            return product.images[0].src || product.images[0].url || "";
        }
        if (product && product.featuredImage && product.featuredImage.url) return product.featuredImage.url;
        if (product && product.image) return product.image.url || product.image.src || "";
        return "";
    }

    function getImageUrl(image) {
        return image ? image.url || image.src || "" : "";
    }

    function getSecondaryImage(product, primary) {
        var list = [];
        var edges = product && product.images && product.images.edges;

        if (Array.isArray(edges)) {
            list = edges.map(function (edge) { return getImageUrl(edge && edge.node); });
        } else if (product && Array.isArray(product.images)) {
            list = product.images.map(function (image) {
                return typeof image === "string" ? image : getImageUrl(image);
            });
        }

        return list.find(function (url) { return url && url !== primary; }) || "";
    }

    function findProductItem(products, id) {
        var target = normalizeId(id);
        var list = products || [];

        for (var i = 0; i < list.length; i++) {
            var product = list[i];
            var variants = getVariants(product);

            if (normalizeId(product.id) === target || normalizeId(product.legacyResourceId) === target) {
                var available = variants.find(isVariantAvailable);
                return available ? { product: product, variant: available } : null;
            }

            var match = variants.find(function (v) {
                return normalizeId(v.id) === target || normalizeId(v.legacyResourceId) === target;
            });
            if (match) return isVariantAvailable(match) ? { product: product, variant: match } : null;
        }
        return null;
    }

    // "section_full_routine_cleanser" -> "Cleanser"; returns "" when the key only names the tab.
    function getStepLabel(sectionKey, tab) {
        return sectionKey
            .replace(/^section_/i, "")
            .replace(tab.match, "")
            .replace(/routine/i, "")
            .replace(/_+/g, " ")
            .trim()
            .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
    }

    function isTabKey(key) {
        return TABS.some(function (tab) { return tab.match.test(key); });
    }

    // Step name comes from the non-tab section listing the product, e.g. section_cleanse -> "Cleanse".
    function getProductSectionLabel(productSections, item) {
        var ids = [item.product.id, item.product.legacyResourceId, item.variant.id, item.variant.legacyResourceId]
            .map(normalizeId)
            .filter(Boolean);

        var sectionKey = Object.keys(productSections).find(function (key) {
            if (isTabKey(key)) return false;
            return (productSections[key] || []).some(function (id) {
                return ids.indexOf(normalizeId(id)) !== -1;
            });
        });

        if (!sectionKey) return "";
        return sectionKey
            .replace(/^section_/i, "")
            .replace(/_+/g, " ")
            .trim()
            .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
    }

    // --- Build ---

    // Prefer text stored under the tab's product section key, then any text_sections key naming the tab.
    function getTabTextHtml(data, tab, sectionKeys) {
        var textKeys = Object.keys((data && data.text_sections) || {});
        var candidates = sectionKeys.concat(textKeys.filter(function (key) {
            return tab.match.test(key) && sectionKeys.indexOf(key) === -1;
        }));

        for (var i = 0; i < candidates.length; i++) {
            var html = textSectionHtml(data, candidates[i]);
            if (html.trim()) return html;
        }
        return "";
    }

    function getAddOnItems(data) {
        var seen = {};
        var items = [];

        (((data && data.product_sections) || {})[ADD_ON_SECTION_KEY] || []).forEach(function (id) {
            var item = findProductItem(data.products, id);
            var key = item && normalizeId(item.product.id);
            if (!item || seen[key]) return;
            seen[key] = true;
            items.push(item);
        });
        return items;
    }

    function buildTabs(data) {
        var productSections = (data && data.product_sections) || {};
        var keys = Object.keys(productSections);
        var addOnItems = getAddOnItems(data);
        var addOnTextHtml = textSectionHtml(data, ADD_ON_SECTION_KEY);

        return TABS.map(function (tab) {
            var seen = {};
            var items = [];
            var tabKeys = keys.filter(function (key) { return tab.match.test(key); });
            var textHtml = getTabTextHtml(data, tab, tabKeys);

            tabKeys.forEach(function (sectionKey) {
                (productSections[sectionKey] || []).forEach(function (id) {
                    var item = findProductItem(data.products, id);
                    var key = item && normalizeId(item.product.id);
                    if (!item || seen[key]) return;
                    seen[key] = true;
                    item.stepLabel = getProductSectionLabel(productSections, item) || getStepLabel(sectionKey, tab);
                    items.push(item);
                });
            });

            return {
                key: tab.key,
                label: tab.label,
                textHtml: textHtml,
                items: items,
                addOns: addOnItems,
                addOnTextHtml: addOnTextHtml,
            };
        }).filter(function (tab) {
            return tab.items.length;
        });
    }

    // --- Render ---

    var SELFIE_FALLBACK_URL =
        "https://cdn.shopify.com/s/files/1/0462/0501/0073/files/skincliquerecselfiealt.webp?v=1791445399";

    function renderTop(data) {
        var img = document.getElementById("sc-reco-selfie");
        var copy = document.getElementById("sc-reco-top-copy");
        var selfieUrl = data && data.selfie_url && String(data.selfie_url).trim();
        var description = textSectionHtml(data, "section_selfie");

        if (img) {
            img.addEventListener("error", function () {
                if (img.getAttribute("src") === SELFIE_FALLBACK_URL) return;
                img.src = SELFIE_FALLBACK_URL;
                img.alt = "Your skin profile";
            });

            if (selfieUrl && selfieUrl !== "#") {
                img.src = selfieUrl;
                img.alt = "Your selfie";
            }
        }

        if (copy) {
            copy.innerHTML = description;
            copy.hidden = !description.trim();
        }
    }

    function getFieldValue(field) {
        return field && typeof field === "object" && "value" in field ? field.value : field;
    }

    // reviewsAverage.value is a JSON string: {"scale_min":"1.0","scale_max":"5.0","value":"4.6"}
    function getProductReviews(product) {
        var raw = getFieldValue(product.reviewsAverage);
        var rating = raw;
        var scaleMax = 5;

        if (typeof raw === "string" && raw.trim().charAt(0) === "{") {
            try {
                rating = JSON.parse(raw);
            } catch (err) {
                rating = null;
            }
        }
        if (rating && typeof rating === "object") {
            scaleMax = Number(rating.scale_max) || 5;
            rating = rating.value;
        }

        var average = (Number(rating) / scaleMax) * 5;
        if (Number.isNaN(average) || average <= 0) return null;

        var count = parseInt(getFieldValue(product.reviewsCount), 10);
        return {
            average: Math.min(Math.max(average, 0), 5),
            count: count && !Number.isNaN(count) ? count : 0
        };
    }

    function renderProductReviews(product) {
        var reviews = getProductReviews(product);
        if (!reviews) return "";

        var label = reviews.average.toFixed(1) + " out of 5 stars" +
            (reviews.count ? ", " + reviews.count + " reviews" : "");

        return (
            '<div class="sc-reco-card__reviews" role="img" aria-label="' + label + '">' +
            '<span class="sc-reco-stars" style="--rating: ' + reviews.average + ';" aria-hidden="true"></span>' +
            (reviews.count
                ? '<span class="sc-reco-card__reviews-count" aria-hidden="true">(' +
                reviews.count.toLocaleString() + ")</span>"
                : "") +
            "</div>"
        );
    }

    var FULL_DISCOUNT_LABEL = "15% off applied";
    var FULL_DISCOUNT_CODE = "FULLROUTINE15";

    // --- Routine timing (tangent-routine-config.js) ---

    var ROUTINE_CONFIG = typeof routineConfig !== "undefined" ? routineConfig : {};
    var personaTimings = null;

    // Persona comes from the quiz tags, e.g. "persona_acne_prone" or "combo_acne_anti_aging".
    function setPersonaFromTags(data) {
        var tags = Array.isArray(data && data.tags) ? data.tags : [];
        var persona = tags.map(function (tag) { return String(tag).trim(); })
            .find(function (tag) { return ROUTINE_CONFIG[tag]; });

        personaTimings = persona ? ROUTINE_CONFIG[persona] : null;
    }

    function getProductTiming(product) {
        var ids = [product.legacyResourceId, product.id].map(normalizeId).filter(Boolean);
        var sources = personaTimings ? [personaTimings] : Object.keys(ROUTINE_CONFIG).map(function (key) {
            return ROUTINE_CONFIG[key];
        });

        for (var i = 0; i < sources.length; i++) {
            for (var j = 0; j < ids.length; j++) {
                var entry = sources[i][ids[j]];
                if (entry && Array.isArray(entry.timing) && entry.timing.length) {
                    return entry.timing.join(" / ");
                }
            }
        }
        return "";
    }

    // buttonType: "cart" (direct add to bag) or "" (no button).
    // hideStep drops the step row (step number, label and AM/PM timing) for add-on cards.
    function renderProductCard(item, index, buttonType, hideStep) {
        var product = item.product;
        var variantId = normalizeId(item.variant.legacyResourceId || item.variant.id);
        var url = product.handle ? "/products/" + product.handle : "#";
        var image = getProductImage(product, item.variant);
        var hoverImage = getSecondaryImage(product, image);
        var title = escapeHtml(product.title);
        var timing = getProductTiming(product);

        return (
            '<article class="sc-reco-card' + (hoverImage ? " has-hover-image" : "") + '">' +
            (hideStep ? "" :
                '<p class="sc-reco-card__step">Step ' + (index + 1) +
                (item.stepLabel || timing
                    ? '<span class="sc-reco-card__step-label">' +
                    escapeHtml(item.stepLabel || "") +
                    (timing ? '<span class="sc-reco-card__timing">' + escapeHtml(timing) + "</span>" : "") +
                    "</span>"
                    : "") +
                "</p>") +
            '<div class="sc-reco-card__media">' +
            '<a class="sc-reco-card__image" href="' + url + '">' +
            (image ? '<img class="sc-reco-card__img" src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">' : "") +
            (hoverImage ? '<img class="sc-reco-card__img sc-reco-card__img--hover" src="' + escapeHtml(hoverImage) + '" alt="" aria-hidden="true" loading="lazy">' : "") +
            "</a>" +
            (buttonType === "cart"
                ? '<button type="button" class="sc-reco-card__add button" data-variant-id="' +
                escapeHtml(variantId) + '">ADD TO BAG</button>'
                : "") +
            "</div>" +
            '<div class="sc-reco-card__body">' +
            '<h3 class="sc-reco-card__title"><a href="' + url + '">' + title + "</a></h3>" +
            renderProductReviews(product) +
            '<p class="sc-reco-card__price">' + formatMoney(getVariantAmount(item.variant)) + "</p>" +
            "</div>" +
            "</article>"
        );
    }

    function renderAddOnSection(tab) {
        if (!tab.addOns.length) return "";

        return (
            '<section class="sc-reco__addons">' +
            '<h2 class="sc-reco__addons-title">Add On For Pregnant Users</h2>' +
            (tab.addOnTextHtml ? '<div class="sc-reco__copy sc-reco__addons-copy rte">' + tab.addOnTextHtml + "</div>" : "") +
            '<div class="sc-reco__grid">' + tab.addOns.map(function (item, index) {
                return renderProductCard(item, index, "cart", true);
            }).join("") + "</div>" +
            "</section>"
        );
    }

    function renderTabs(tabs) {
        tabsEl.innerHTML = tabs.map(function (tab, index) {
            var active = index === 0;
            return (
                '<button type="button" class="sc-reco__tab' + (active ? " is-active" : "") + '"' +
                ' role="tab" id="sc-reco-tab-' + tab.key + '"' +
                ' aria-controls="sc-reco-panel-' + tab.key + '"' +
                ' aria-selected="' + active + '" tabindex="' + (active ? "0" : "-1") + '"' +
                ' data-tab="' + tab.key + '">' +
                escapeHtml(tab.label) +
                "</button>"
            );
        }).join("");

        panelsEl.innerHTML = tabs.map(function (tab, index) {
            var cardButton = tab.key === "byob" ? "cart" : "";
            return (
                '<div class="sc-reco__panel" role="tabpanel" id="sc-reco-panel-' + tab.key + '"' +
                ' aria-labelledby="sc-reco-tab-' + tab.key + '" data-panel="' + tab.key + '"' +
                (index === 0 ? "" : " hidden") + ">" +
                (tab.textHtml ? '<div class="sc-reco__copy rte">' + tab.textHtml + "</div>" : "") +
                '<div class="sc-reco__grid">' + tab.items.map(function (item, index) {
                    return renderProductCard(item, index, cardButton);
                }).join("") + "</div>" +
                (tab.key === "byob"
                    ? ""
                    : '<div class="sc-reco__add-all-wrap">' +
                    (tab.key === "full"
                        ? '<button type="button" class="sc-reco__discount button" tabindex="-1" aria-disabled="true">' +
                        escapeHtml(FULL_DISCOUNT_LABEL) + "</button>"
                        : "") +
                    '<button type="button" class="sc-reco__add-all button" data-variant-ids="' +
                    escapeHtml(tab.items.map(function (item) {
                        return normalizeId(item.variant.legacyResourceId || item.variant.id);
                    }).join(",")) + '">' +
                    escapeHtml(getAddAllButtonText(tab.key)) +
                    "</button>" +
                    "</div>") +
                renderAddOnSection(tab) +
                "</div>"
            );
        }).join("");

        if (tabsEl.dataset.bound !== "true") {
            tabsEl.dataset.bound = "true";

            tabsEl.addEventListener("click", function (event) {
                var tab = event.target.closest(".sc-reco__tab");
                if (tab) selectTab(tab.getAttribute("data-tab"));
            });

            tabsEl.addEventListener("keydown", function (event) {
                if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;

                var buttons = Array.prototype.slice.call(tabsEl.querySelectorAll(".sc-reco__tab"));
                var current = buttons.indexOf(document.activeElement);
                if (current === -1) return;

                var step = event.key === "ArrowRight" ? 1 : -1;
                var next = buttons[(current + step + buttons.length) % buttons.length];
                next.focus();
                selectTab(next.getAttribute("data-tab"));
            });
        }

        if (panelsEl.dataset.bound !== "true") {
            panelsEl.dataset.bound = "true";
            panelsEl.addEventListener("click", function (event) {
                var button = event.target.closest(".sc-reco-card__add, .sc-reco__add-all");
                if (button) handleAdd(button);
            });
        }
    }

    function getAddAllButtonText(tabKey) {
        if (tabKey === "full") return "Add Full Routine to Cart";
        if (tabKey === "starter") return "Add Starter Set to Cart";
        return "Add to Cart";
    }

    function selectTab(key) {
        tabsEl.querySelectorAll(".sc-reco__tab").forEach(function (tab) {
            var active = tab.getAttribute("data-tab") === key;
            tab.classList.toggle("is-active", active);
            tab.setAttribute("aria-selected", active);
            tab.setAttribute("tabindex", active ? "0" : "-1");
        });

        panelsEl.querySelectorAll("[data-panel]").forEach(function (panel) {
            panel.hidden = panel.getAttribute("data-panel") !== key;
        });
    }

    // --- Cart ---

    function emit(name, detail) {
        document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    }

    // The theme's quick-cart events live in a bundled pub/sub that outside scripts can't reach,
    // so drive the registered quick-cart section instance directly.
    function openQuickCart() {
        document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));

        var sections = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
        var quickCart = sections && Array.isArray(sections.instances)
            ? sections.instances.find(function (instance) { return instance.type === "quick-cart"; })
            : null;

        if (quickCart && typeof quickCart.openQuickCart === "function") {
            if (typeof quickCart.refreshQuickCart === "function") quickCart.refreshQuickCart();
            quickCart.openQuickCart();
            return;
        }

        var cartIcon = document.querySelector("[data-js-cart-icon]");
        if (cartIcon && document.querySelector(".quick-cart")) {
            cartIcon.click();
            return;
        }

        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart";
    }

    function handleAdd(button) {
        var variantIds = (
            button.getAttribute("data-variant-ids") ||
            button.getAttribute("data-variant-id") ||
            ""
        )
            .split(",")
            .filter(Boolean);

        if (!variantIds.length || button.disabled) return;

        var originalText = button.textContent;
        button.disabled = true;
        button.setAttribute("data-busy", "true");
        button.classList.add("is-loading");
        button.textContent = "Adding...";

        var panel = button.closest("[data-panel]");
        var tabKey = panel ? panel.getAttribute("data-panel") : "";

        var isAddon = !!button.closest(".sc-reco__addons");
        var isFullAddAll = !isAddon &&
            tabKey === "full" &&
            button.classList.contains("sc-reco__add-all");

        var tabProperties = {
            starter: { _from: "tangent_add_starter_set" },
            byob: { _from: "tangent_add_build_your_own" },
            full: { _from: "tangent_add_full_routine" }
        };

        var properties = isAddon
            ? { _from: "tangent_add_on_add_to_bag" }
            : (tabProperties[tabKey] || {});

        fetch(CART_ADD_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                items: variantIds.map(function (id) {
                    return {
                        id: Number(id),
                        quantity: 1,
                        properties: properties
                    };
                })
            })
        })
            .then(function (response) {
                if (!response.ok) {
                    return response.json().then(function (err) {
                        throw err;
                    });
                }

                return response.json();
            })
            .then(function () {
                button.textContent = "Added!";

                // Discount only for Full Routine add-all.
                if (!isFullAddAll) {
                    openQuickCart();
                    return;
                }

                var rootPath =
                    window.Shopify &&
                        window.Shopify.routes &&
                        window.Shopify.routes.root
                        ? window.Shopify.routes.root
                        : "/";

                return fetch(
                    rootPath + "discount/" + encodeURIComponent(FULL_DISCOUNT_CODE),
                    { credentials: "same-origin", redirect: "follow" }
                )
                    .catch(function (err) {
                        console.error(
                            "[Skin Clique reco] discount application failed",
                            err
                        );
                    })
                    .then(function () {
                        openQuickCart();
                    });
            })
            .catch(function (err) {
                var message =
                    (err && (err.description || err.message)) ||
                    "Couldn't add to cart";

                console.error("[Skin Clique reco] add to cart failed", err);

                button.textContent = "Try again";
                emit("cart:error", { errorMessage: message });
            })
            .finally(function () {
                button.classList.remove("is-loading");

                setTimeout(function () {
                    button.removeAttribute("data-busy");
                    button.textContent = originalText;
                    button.disabled = false;
                }, 2000);
            });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
